<template>
  <div v-if="load && showContent">
    <v-skeleton-loader type="article"></v-skeleton-loader>
  </div>
  <div v-else>
    <div v-if="showContent">
      <v-row class="ma-0" justify="start">
        <v-col v-for="(record, key) in list" :key="key">
          <v-chip class="ma-1" style="white-space: nowrap;">
            <v-dialog max-width="500" v-if="record.tooltip">
              <template v-slot:activator="{ props: activatorProps }">
                <v-btn icon="mdi-help" variant="text" size="x-small" color="black" v-bind="activatorProps"></v-btn>
              </template>
              <v-card>
                <v-card-text>
                  <span v-html="record.tooltip"></span>
                </v-card-text>
              </v-card>
            </v-dialog>
            {{ record.title }}:
            <span :class="record.color + ` pa-2`">
              {{ record.info }}
            </span></v-chip>
        </v-col>
      </v-row>
    </div>
    <div v-else class="cursor-pointer">
      <v-col class="d-flex flex-column align-center">
        <v-icon color="info" icon="mdi-server"></v-icon>
      </v-col>

      <v-col style="word-break: break-word" class="d-flex flex-column align-center">
        <span>Статус сервера</span>
      </v-col>
    </div>

  </div>

</template>

<script>
export default {
  props: {
    //поле data из psm_desktop_widgets
    data: {
      required: true,
    },
    showContent: {
      default: false,
      type: Boolean
    }
  },
  name: "serverInfoWidget",
  data() {
    return {
      list: [],
      load: false
    };
  },
  watch: {
    showContent: function (newVal) {
      if (newVal && this.list.length == 0) {
        this.loadData();
      }
    }
  },
  created() {
    if (!this.showContent) {
      return
    }
    this.loadData();
  },
  methods: {
    loadData() {
      this.load = true;
      this.axios
        .post(
          this.$model.wwwroot +
          "/procollege/index.php/core_procollege/helpers/ServerInfo/get"
        )
        .then((response) => {
          this.list = response.data.data;
          this.load = false;
        })
        .catch((error) => {
          this.load = false;
          console.log(error);
        });
    }
  },
};
</script>
<style lang="scss">
#procollege_desktop2 {
  .pointer {
    cursor: pointer;
  }
}
</style>
